module.exports = __webpack_public_path__ + "img/流体力学3_5_3.6606c818.jpg";